import { createHelpers } from 'vuex-map-fields';
const { getUfilterField, updateUfilterField } = createHelpers({
    getterType: `getUfilterField`,
    mutationType: `updateUfilterField`,
});


const state = {
    groups : [],
    exclude : [],
    active_groups : [],
    search : '',
    filter_type : "all",
}

// actions
const actions = {

    SET_FILTER_TYPE({commit}, data) {
        commit('set_filter_type', data)
    },

    SET_GROUPS_LIST({commit}, data) {
        commit('set_groups_list', data)
    },

    SET_ACTIVE_GROUPS_LIST ({commit}, data) {
        commit('set_active_group_list',data)
    },

    SET_SEARCH ({commit}) {
        commit('set_search')
    },

    SET_ACTIVE_EXCLUDE ({commit}, data) {
        commit('set_active_exclude', data)
    },

    CLEAN ({commit}){
        commit('clean');
    },
}

const getters = {
    getUfilterField,
};


// mutations
const mutations = {

    updateUfilterField,

    set_filter_type(state,data) {
        state.filter_type = data;
    },

    set_search(state,data) {
        state.search = data;
    },

    set_groups_list(state,data) {
        state.groups = data;
    },

    set_active_group_list(state,data) {
        if(data == undefined) {
            data = [];
        }
        state.active_groups = data;
    },

    set_active_exclude(state,data) {
        if(data == undefined) {
            data = [];
        }
        state.exclude = data;
    },

    clean (state) {
        //    state.users = [];
        //    state.exclude = [];
        //    state.active_users = [];
    }

}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
